import React from "react";
import SEO from "../../SEO";

const FeatureItem = ({ title, desc }) => (
  <div className="expertise-item">
    <span className="icon">✓</span>

    <div>
      <h5>{title}</h5>
      <p>{desc}</p>
    </div>
  </div>
);

const majorModules = [
  {
    title: "Dashboard",
    icon: "bi-speedometer2",
    description:
      "Real-time dashboard for monitoring sales, inventory, expenses and business performance.",
    img: process.env.PUBLIC_URL + "/img/RestaurantInventoryApp/Dashboard.png",
  },
  {
    title: "Restaurant POS",
    icon: "bi-shop-window",
    description:
      "Fast billing system with inventory integration and restaurant order management.",
    img:
      process.env.PUBLIC_URL + "/img/RestaurantInventoryApp/RestaurantPOS.png",
  },
  {
    title: "Kitchen Display System",
    icon: "bi-display",
    description:
      "Digital kitchen display for live order tracking and improved restaurant workflow.",
    img:
      process.env.PUBLIC_URL +
      "/img/RestaurantInventoryApp/KitchenDisplaySystem.png",
  },
  {
    title: "Recipe Maker",
    icon: "bi-book",
    description:
      "Manage recipes, ingredients and food costing with detailed recipe management tools.",
    img:
      process.env.PUBLIC_URL + "/img/RestaurantInventoryApp/ReceipeMaker.png",
  },
  {
    title: "Chart Of Account",
    icon: "bi-graph-up",
    description:
      "Professional accounting structure with ledger, vouchers and financial reports.",
    img:
      process.env.PUBLIC_URL + "/img/RestaurantInventoryApp/ChartOfAccount.png",
  },
  {
    title: "Trail Balance",
    icon: "bi-journal-check",
    description:
      "Generate accurate trial balance and accounting reports instantly.",
    img:
      process.env.PUBLIC_URL + "/img/RestaurantInventoryApp/TrailBalance.png",
  },
];

const otherFeatures = [
  "Category Management",
  "Customer Tracking",
  "Product & Stock Control",
  "Supplier & Vendor Management",
  "Bank Account Tracking",
  "Expense Management",
  "Journal & Payment Vouchers",
  "Role-based Permissions",
  "Product Barcode Generation",
  "Supplier Payments",
  "User Access Panel",
  "Vendor Settlement",
  "Account Reconciliation",
];

const faqs = [
  {
    question: "Which businesses can use this ERP software?",
    answer:
      "This ERP system is ideal for restaurants, supermarkets, retail stores, pharmacies, wholesalers and growing businesses.",
  },
  {
    question: "Does this ERP software include POS billing?",
    answer:
      "Yes, the ERP includes a complete POS billing system integrated with inventory and accounting.",
  },
  {
    question: "Can I manage inventory with this software?",
    answer:
      "Yes, the software provides advanced inventory management with stock tracking and reporting.",
  },
  {
    question: "Do you provide accounting modules?",
    answer:
      "Yes, accounting modules include chart of accounts, vouchers, expenses, trial balance and reports.",
  },
  {
    question: "Is the ERP software customizable?",
    answer:
      "Yes, MZR Software provides fully customized ERP solutions according to business workflow and requirements.",
  },
  {
    question: "Do you provide support after deployment?",
    answer:
      "Yes, we provide complete technical support, training and maintenance services.",
  },
];

function EnterpriseERP() {
  return (
    <>
      <SEO
        title="ERP Software for Restaurants & Businesses in Pakistan | MZR Software"
        description="Complete ERP software for restaurants and businesses including POS, inventory, accounting, and reporting system."
        url="/erp-software"
      />

      <div className="portfolio-section">
        <div className="container">
          {/* ========================= */}
          {/* H1 */}
          {/* ========================= */}

          <div className="section-header text-center mb-5">
            <h1 className="section-title">
              ERP Software for Restaurants & Businesses in{" "}
              <span className="highlight">Pakistan</span>
            </h1>

            <p className="section-subtitle">
              Complete ERP software with POS billing, inventory management,
              accounting, reporting and restaurant automation solutions.
            </p>
          </div>

          {/* ========================= */}
          {/* INTRODUCTION */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h2 className="text-white mb-4">
                  Introduction to Our ERP Software
                </h2>

                <p className="text-light">
                  MZR Software provides advanced ERP software for restaurants,
                  retail stores and businesses in Pakistan. Our system helps
                  businesses automate billing, inventory, accounting and
                  operations from one centralized platform.
                </p>

                <p className="text-light">
                  The software is designed for speed, scalability and business
                  growth with modern features including POS billing, kitchen
                  display systems, financial management and reporting tools.
                </p>

                <div className="hero-trust mt-4">
                  ✔ Inventory Management <br />
                  ✔ Restaurant POS System <br />
                  ✔ Accounting & Reports <br />✔ Business Automation
                </div>
              </div>

              <div className="col-lg-6 text-center">
                <iframe
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/6unp9xeoQMQ"
                  title="ERP Demo"
                  frameBorder="0"
                  allowFullScreen
                  style={{
                    borderRadius: "20px",
                    boxShadow: "0 10px 30px rgba(0,212,255,0.2)",
                  }}
                ></iframe>
              </div>
            </div>
          </section>

          {/* ========================= */}
          {/* FEATURES */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">ERP Software Features</h2>

              <p className="section-subtitle">
                Powerful modules for restaurants, retail stores and businesses.
              </p>
            </div>

            <div className="portfolio-grid">
              {majorModules.map((module, index) => (
                <div key={index} className="portfolio-card">
                  <div className="card-image-wrapper">
                    <img
                      src={module.img}
                      alt={module.title}
                      className="project-video"
                    />

                    <div className="card-overlay">
                      <i
                        className={`bi ${module.icon} project-icon text-info`}
                      ></i>
                    </div>
                  </div>

                  <div className="card-content">
                    <h5 className="card-title">{module.title}</h5>

                    <p className="card-description">{module.description}</p>

                    <div className="card-category">
                      <span className="category-badge">ERP MODULE</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Additional Features */}

            <div className="row mt-5">
              <div className="col-lg-6">
                <div className="expertise-list">
                  {otherFeatures.slice(0, 7).map((f, i) => (
                    <FeatureItem
                      key={i}
                      title={f}
                      desc="Advanced ERP system feature."
                    />
                  ))}
                </div>
              </div>

              <div className="col-lg-6">
                <div className="expertise-list">
                  {otherFeatures.slice(7).map((f, i) => (
                    <FeatureItem
                      key={i}
                      title={f}
                      desc="Business management integration."
                    />
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* ========================= */}
          {/* BENEFITS */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">Benefits of Our ERP Software</h2>

              <p className="section-subtitle">
                Improve efficiency, reduce errors and automate your business.
              </p>
            </div>

            <div className="row g-4">
              <div className="col-md-3">
                <div className="stat-box text-center">
                  <span className="stat-value">100%</span>
                  <span className="stat-text">Offline Capable</span>
                </div>
              </div>

              <div className="col-md-3">
                <div className="stat-box text-center">
                  <span className="stat-value">Real-time</span>
                  <span className="stat-text">Inventory Tracking</span>
                </div>
              </div>

              <div className="col-md-3">
                <div className="stat-box text-center">
                  <span className="stat-value">24/7</span>
                  <span className="stat-text">Technical Support</span>
                </div>
              </div>

              <div className="col-md-3">
                <div className="stat-box text-center">
                  <span className="stat-value">Secure</span>
                  <span className="stat-text">Data Protection</span>
                </div>
              </div>
            </div>
          </section>

          {/* ========================= */}
          {/* SCREENSHOTS */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">ERP Software Screenshots</h2>

              <p className="section-subtitle">
                Explore the interface and major ERP modules.
              </p>
            </div>

            <div className="portfolio-grid">
              {majorModules.map((module, index) => (
                <div key={index} className="portfolio-card">
                  <div className="card-image-wrapper">
                    <img
                      src={module.img}
                      alt={module.title}
                      className="project-image"
                    />
                  </div>

                  <div className="card-content text-center">
                    <h5>{module.title}</h5>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* ========================= */}
          {/* INDUSTRIES */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">
                Industries Using Our ERP Software
              </h2>

              <p className="section-subtitle">
                ERP solutions for multiple industries in Pakistan.
              </p>
            </div>

            <div className="industries-grid">
              <div className="industry-card">🍔 Restaurant Management</div>

              <div className="industry-card">🛒 Retail POS Software</div>

              <div className="industry-card">💊 Pharmacy Inventory</div>

              <div className="industry-card">🏬 Supermarket ERP</div>

              <div className="industry-card">🚚 Distribution Management</div>

              <div className="industry-card">🏫 School Management</div>

              <div className="industry-card">📦 Warehouse Management</div>

              <div className="industry-card">🧾 Accounting Automation</div>
            </div>
          </section>

          {/* ========================= */}
          {/* FAQS */}
          {/* ========================= */}

          <section className="mb-5">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">ERP Software FAQs</h2>

              <p className="section-subtitle">
                Common questions about ERP software and POS systems.
              </p>
            </div>

            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header" id={`faq${index}`}>
                    <button
                      className={`accordion-button ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                    >
                      {faq.question}
                    </button>
                  </h2>

                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">{faq.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* ========================= */}
          {/* CTA */}
          {/* ========================= */}

          <section className="portfolio-cta text-center mt-5 pt-4">
            <h2 className="mb-4 text-white">
              Ready to Automate Your Business?
            </h2>

            <p className="cta-text">
              Start your ERP software project today with MZR Software.
            </p>

            <a
              href="https://wa.me/923351206586?text=Hi%20I%20need%20ERP%20software"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              🚀 Get Free Consultation on WhatsApp
            </a>
          </section>
        </div>
      </div>
    </>
  );
}

export default EnterpriseERP;
